import {useMutation, UseMutationOptions, useQueryClient} from '@tanstack/react-query'
import {QUERY_KEYS} from '@/queryClient.ts'
import {httpSubmitToAirbnb} from '@features/assignment/http/assignment.http'
import {Assignment} from '@features/assignment/types.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {captureException} from '@sentry/react'
import {parseAxiosPromise} from '@/axiosInstance.ts'

export const useSubmitToAirbnb = ({
    assignmentId,
    options
}: {
    assignmentId: Assignment['id']
    options?: Omit<UseMutationOptions<Assignment, unknown, string>, 'mutationFn'>
}) => {
    const queryClient = useQueryClient()

    return useMutation({
        ...options,
        mutationFn: (photographer_notes: string) =>
            parseAxiosPromise({
                axiosPromise: httpSubmitToAirbnb({
                    params: {
                        photographer_notes: photographer_notes,
                        response_type: 'extended'
                    },
                    urlParams: {assignmentId: assignmentId}
                }),
                responseShape: Assignment,
                onZodError: captureException
            }),
        onSuccess: (data, variables, context) => {
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.CURRENT_ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVE_ASSIGNMENTS_RANGE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ACTIVE_ASSIGNMENTS_TABLE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS_COUNT]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.ASSIGNMENTS]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.HOME_TABLE]})
            void queryClient.invalidateQueries({queryKey: [QUERY_KEYS.REQUIRED_ACTIONS]})
            void queryClient.setQueriesData({queryKey: [QUERY_KEYS.ASSIGNMENT, data.code]}, data)
            options?.onSuccess?.(data, variables, context)
        },
        onError: errorHandler
    })
}
